import { createRootRoute, Outlet, redirect } from '@tanstack/react-router';

import { getCurrentSession } from '../app/auth-state';
import { OPERATOR_ROLE } from '../modules/auth/domain/entities/session';
import { InstallPrompt } from '../modules/shell/ui/InstallPrompt';
import { StatusToast } from '../modules/shell/ui/StatusToast';
import { UpdateAvailableToast } from '../modules/shell/ui/UpdateAvailableToast';

export const Route = createRootRoute({
  component: () => (
    <div className="min-h-screen">
      <Outlet />
      <InstallPrompt />
      <UpdateAvailableToast />
      <StatusToast />
    </div>
  ),
  // Direct hits to a route the PWA does not own (e.g. /admin/settings) land
  // here. Bounce the operator back to /queue with a flash message instead of
  // showing a 404 — escenario 2 de JQ4-7.
  notFoundComponent: () => {
    const session = getCurrentSession();
    if (session?.user.role === OPERATOR_ROLE) {
      throw redirect({ to: '/queue', search: { denied: 1 } });
    }
    throw redirect({ to: '/login' });
  },
});
